import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class Excelservice {

  exportExcel(apiResponse: any, fileName: any) {
    if (!apiResponse) {
      return;
    }
    const ws: XLSX.WorkSheet = {};
    let currentRow = 0;
    const dataObject = apiResponse;
    if (fileName) {
      const maxCols = Math.max(
        ...Object.values(dataObject)
          .map((sec: any) => Object.keys(sec[0] || {}).length)
      );
      const formNameCell = XLSX.utils.encode_cell({ r: currentRow, c: 0 });
      ws[formNameCell] = {
        v: fileName,
        s: {
          font: {
            sz: 16,
            bold: true,
            color: { rgb: 'ffffff' }
          },
          fill: {
            fgColor: { rgb: '8d1d75' }
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          },
          border: {
            top: { style: 'medium' },
            bottom: { style: 'medium' },
            left: { style: 'medium' },
            right: { style: 'medium' }
          }
        }
      };
      if (!ws['!merges']) ws['!merges'] = [];
      ws['!merges'].push({
        s: { r: currentRow, c: 0 },
        e: { r: currentRow, c: maxCols - 1 }
      });
      if (!ws['!rows']) ws['!rows'] = [];
      ws['!rows'][currentRow] = { hpt: 30 };

      currentRow += 2;
    }
    Object.keys(dataObject).forEach(sectionName => {
      const sectionData = dataObject[sectionName];
      if (!sectionData && !sectionData?.length) return;
      const totalCols = Object.keys(sectionData[0]).length;
      sectionData.forEach((row: any, rowIndex: number) => {
        const isTotalRow = Object.values(row).some(v => String(v).toUpperCase() === 'TOTAL');
        Object.keys(row).forEach((key, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({
            r: currentRow,
            c: colIndex
          });
          ws[cellAddress] = {
            v: row[key],
            s: {
              font: {
                sz: rowIndex === 0 || isTotalRow ? 13 : 12,
                bold: rowIndex === 0 || isTotalRow,
                color: rowIndex === 0 ? { rgb: "8d1d75" } : isTotalRow ? { rgb: "86688c" } : { rgb: "" }
              },
              fill: {
                fgColor: rowIndex != 0 && isTotalRow ? { rgb: 'e6cfeb' } : { rgb: "ffffff" }
              },
              border: {
                top: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              }
            }
          };
        });
        currentRow++;
      });
      currentRow += 2;
    });
    const maxCols = Math.max(
      ...Object.values(dataObject)
        .map((sec: any) => Object.keys(sec[0] || {}).length)
    );
    ws['!cols'] = Array(maxCols).fill({ wch: 18 });
    ws['!ref'] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: {
        r: currentRow - 1,
        c: maxCols - 1
      }
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileName);
    const buffer =
      XLSX.write(wb, {
        type: 'array',
        bookType: 'xlsx'
      });
    saveAs(new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }), fileName);
  }
}
